<template>
    <Dropdown
        ref="buscador"
        id="buscador"
        editable
        filter
        showClear
        v-model="texto_buscador"
        :options="servicios"
        optionLabel="nombre"
        :filterFields="[
            'codigo',
            'fecha',
            'estado',
            'nombre',
            'direccion',
            'poblacion',
            'provincia'
        ]"
        placeholder="Buscador Expedientes"
        class="buscador w-full md:w-14rem"
        emptyFilterMessage="No se han encontrado expedientes"
        @update:modelValue="onInput"
    >

        <!-- OPCIONES -->
        <template #option="{ option }">
            <div
                class="dropdown-option"
                @click.stop.prevent="selectOption(option)"
            >
                <b>{{ option.codigo }}</b> ||
                {{ option.fecha }} ||
                {{ option.estado }} ||
                {{ option.nombre }} ||
                {{ option.direccion }} ||
                {{ option.poblacion }} ||
                {{ option.provincia }}

                <div v-if="option.numero_servicio" style="font-size: small;">
                    {{ option.numero_servicio }}
                </div>
            </div>
        </template>

        <!-- MENSAJES -->
        <template #empty>
            <div class="p-2 text-gray-500">
                <span v-if="cargando">
                    Cargando expedientes...
                </span>
                <span v-else-if="!texto_buscador || texto_buscador.length < 3">
                    Introduce al menos 3 caracteres para buscar
                </span>
                <span v-else>
                    No se han encontrado expedientes
                </span>
            </div>
        </template>

    </Dropdown>
</template>

<script>
import Dropdown from 'primevue/dropdown'
import { PwgsApi } from '../../../../../services/PwgsApi'

export default {
    components: { Dropdown },

    data() {
        return {
            texto_buscador: '',
            servicios: [],
            cargando: false,
            actual: 0,
            seleccionado: false
        }
    },

    methods: {

        onInput(value) {
            // Si recibimos un objeto, es que se ha seleccionado una opci�n del dropdown
            if (typeof value === 'object' && value !== null) {
                this.texto_buscador = ''; // Forzamos limpieza si llega el objeto
                return;
            }

            this.texto_buscador = value
            this.actual++

            if (!this.seleccionado) {
                this.servicios = []
            }

            this.seleccionado = false
            this.cargando = true

            const num = this.actual

            setTimeout(() => {
                if (this.actual === num) {
                    if (this.texto_buscador && this.texto_buscador.length > 2) {
                        this.buscarservicios(this.texto_buscador)
                    } else {
                        this.cargando = false
                    }
                }
            }, 800)
        },

        async buscarservicios(texto) {
            try {
                const api = new PwgsApi()
                const response = await api.get(
                    'listados-servicios/buscador?buscador=' +
                    encodeURIComponent(texto.trim())
                )

                this.servicios = response.datos ?? []
                this.$refs.buscador.show()
            } catch (e) {
                console.error(e)
            } finally {
                this.cargando = false
            }
        },
        selectOption(option) {
            this.seleccionado = true;
            
            // Navegamos
            this.iraservicio(option.idservicios, option.codigo);

            // Usamos un timeout de 0. 
            // Esto no espera "tiempo", sino que espera a que la "cola" de procesos 
            // de Vue y PrimeVue termine.
            setTimeout(() => {
                this.texto_buscador = ''; 
                this.servicios = [];
            }, 0);
        },
        iraservicio(idruta, codigo) {
            localStorage.setItem(
                'nombreservicio' + idruta,
                codigo
            )

            this.$router.push('/servicios/' + idruta)
        }
    }
}
</script>

<style>
.p-dropdown-items > .p-dropdown-item:nth-child(even) {
    background: #eeeaea !important;
}

.p-dropdown-items > .p-dropdown-item:hover {
    background-color: #067eff !important;
    color: white !important;
}

.buscador.p-dropdown-panel {
    left: 200px !important;
}

.dropdown-option {
    max-width: 65vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
</style>
